let HttpService = require('../services/http.service');

module.exports = {
  data(){
    return {
      loadingVisible: false,
    };
  },
  methods: {
    createResource: function (params) {
      var self = this;
        
      if(!self.validate()){
        return false;
      }

      HttpService.post(self.resource, params, function(response, error){
        if(error){
          //Handle error
          self.errorMessage = error.message;
        }else{
          self.$router.push({name: self.parentResource});
        }
        self.loadingVisible = false;
      });
    },
  },
};


// WEBPACK FOOTER //
// ./src/mixins/createResource.mixin.js